"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { label } from '../styles.js';
import { useTheme } from '../../utils/theming/useTheme.js';
import { useComponentVariant } from '../../utils/hooks/useComponentVariant.js';

var _excluded = ["item", "isActive", "underlineColor", "textColor", "textSize", "onClick", "onKeyDown", "transparent", "variant"];
// React forwardRef work around for generics
// https://stackoverflow.com/a/58473012/2139665
var TabComponentBody = function TabComponentBody(props, ref) {
  var item = props.item,
    isActive = props.isActive,
    underlineColor = props.underlineColor,
    textColor = props.textColor,
    textSize = props.textSize,
    onClick = props.onClick,
    onKeyDown = props.onKeyDown,
    transparent = props.transparent,
    variantProp = props.variant,
    rest = _objectWithoutProperties(props, _excluded);
  var handleClick = React.useCallback(function (e) {
    e.preventDefault();
    onClick(item.id);
  }, [item, onClick]);
  var theme = useTheme();
  var variant = variantProp || theme.variant;
  var tabsTheme = useComponentVariant(theme.tabs.web, variant);
  return /*#__PURE__*/React.createElement(label, _extends({
    ref: ref,
    $active: isActive,
    tabIndex: isActive ? 0 : -1,
    "aria-controls": String(item.id),
    "aria-selected": isActive,
    id: "".concat(item.id, "-tab"),
    onClick: handleClick,
    onKeyDownCapture: onKeyDown,
    role: "tab",
    $underlineColor: underlineColor ? underlineColor : tabsTheme.color,
    $textColor: textColor ? textColor : transparent ? theme.tokens.text.desaturated : tabsTheme.textColor,
    $textSize: textSize ? textSize : tabsTheme.fontSize["default"],
    theme: theme,
    $variant: variant,
    $transparent: transparent
  }, rest), item.name);
};
var Tab = /*#__PURE__*/React.forwardRef(TabComponentBody);

export { Tab };
